// src/module/types/index.ts
function isDefined(v) {
  return !(typeof v === "undefined");
}

// src/module/cookies/util.ts
function formatCookie(key, value, config) {
  if (key.trim() === "") {
    throw new Error("Key may not be empty");
  }
  return [
    `${key}=${value}`,
    ...Object.entries(config ?? {}).map(([configKey, configValue]) => {
      if (typeof configValue === "undefined") {
        return;
      }
      if (configValue === true) {
        return configKey;
      }
      if (configValue instanceof Date) {
        configValue = configValue.toUTCString();
      }
      return `${configKey}=${configValue}`;
    })
  ].filter(isDefined).join("; ");
}

// src/module/cookies/index.ts
function setCookie(key, value, config) {
  const cookieString = formatCookie(key, value, config);
  document.cookie = cookieString;
}
function deleteCookie(key, config) {
  document.cookie = formatCookie(key, "", {
    ...config,
    "Max-Age": -999999
  });
}
function getCookie(key) {
  const cookies = document.cookie.split(";").map((i) => i.trim());
  for (const cookie of cookies) {
    const parts = cookie.split("=");
    if (parts.length < 2) {
      continue;
    }
    const name = parts.shift();
    if (name === key) {
      return parts.join("=");
    }
  }
  return void 0;
}
function hasCookie(key) {
  return typeof getCookie(key) !== "undefined";
}
function createCookieManager(config) {
  let _config = config;
  return {
    setConfig(config2) {
      _config = config2;
    },
    getCookie,
    setCookie: (key, value, config2) => {
      setCookie(key, value, { ...config2, ..._config });
    },
    deleteCookie: (key, config2) => {
      deleteCookie(key, { ...config2, ..._config });
    }
  };
}

export { createCookieManager, deleteCookie, getCookie, hasCookie, setCookie };
